import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import Slider from "react-swipe";
import ChapterView from "./ChapterView";
import { withChapter } from "../ChapterContainer";

class SwipableChapterLayout extends React.Component {
  static propTypes = {
    chapter: PropTypes.shape({
      getCurrentChapter: PropTypes.func.isRequired,
      onChapterSwipe: PropTypes.func.isRequired,
      currentChapterId: PropTypes.string.isRequired,
      chapterPanelIds: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    theme: PropTypes.shape({
      scriptDirection: PropTypes.string.isRequired
    }).isRequired,
    setModeDefault: PropTypes.func.isRequired
  };

  state = {
    chapterPanelIds: [],
    currentPanelIndex: 0
  };

  shouldComponentUpdate(nextProps, nextState) {
    const { currentChapterId, getCurrentChapter } = nextProps.chapter;
    const { chapterPanelIds, currentPanelIndex } = nextState;

    const newChapterIndex = this.getSlideIndex({
      currentChapterId,
      chapterPanelIds
    });
    const isNewChapterId =
      currentChapterId !== this.props.chapter.currentChapterId;
    const isNewPanelIndex = currentPanelIndex !== this.state.currentPanelIndex;
    const prevChapterIndex = this.getSlideIndex({
      currentChapterId: this.props.chapter.currentChapterId,
      chapterPanelIds: this.state.chapterPanelIds
    });

    const isNewPanelIdLoad =
      prevChapterIndex === -1 ||
      (chapterPanelIds.length > 1 && this.state.currentPanelIndex === 0);

    const shouldUpdate =
      getCurrentChapter() &&
      (isNewPanelIdLoad ||
        // panelIds have changed and the index needs to be updated to reflect and trigger re-render of slider
        newChapterIndex <= 1 ||
        newChapterIndex >= chapterPanelIds.length - 2 ||
        // swipe has happened and we're now close to the end/start of panelIds list
        (isNewChapterId &&
          !isNewPanelIndex &&
          newChapterIndex !== currentPanelIndex) ||
        currentPanelIndex > newChapterIndex + 2); // chapterId updated, but not due to a swipe
    return shouldUpdate || false;
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.chapterPanelIds) !==
      JSON.stringify(this.props.chapter.chapterPanelIds)
    ) {
      const { chapterPanelIds, currentChapterId } = this.props.chapter;

      const currentPanelIndex = this.getSlideIndex({
        chapterPanelIds,
        currentChapterId
      });

      this.setState({
        chapterPanelIds,
        currentPanelIndex
      });
    }
  }

  getSlideIndex = ({ currentChapterId, chapterPanelIds }) =>
    chapterPanelIds.indexOf(currentChapterId);

  render() {
    const {
      getCurrentChapter,
      currentChapterId,
      onChapterSwipe
    } = this.props.chapter;

    const chapterPanelIds =
      this.props.theme.scriptDirection === "rtl"
        ? this.state.chapterPanelIds.reverse()
        : this.state.chapterPanelIds;

    const startSlide = this.getSlideIndex({
      chapterPanelIds,
      currentChapterId
    });

    if (getCurrentChapter()) {
      return (
        <Slider
          key={`${chapterPanelIds}-${startSlide}`}
          swipeOptions={{
            startSlide,
            transitionEnd: index => {
              this.props.setModeDefault();
              if (index > chapterPanelIds.length - 1 || index <= 1) {
                onChapterSwipe(chapterPanelIds[index]);
              } else {
                this.setState(() => {
                  onChapterSwipe(chapterPanelIds[index]);
                  return { currentPanelIndex: index };
                });
              }
            },
            continuous: false
          }}
        >
          {chapterPanelIds.map(panelChapterId => (
            <div key={panelChapterId}>
              <ChapterView
                touchEnabled
                isCurrentChapter={currentChapterId === panelChapterId}
                chapterId={panelChapterId}
              />
            </div>
          ))}
        </Slider>
      );
    }
    return null;
  }
}

export default withChapter(withTheme(SwipableChapterLayout));
